import templateBase from './templates/account-menu.html';

function accountMenuDirective() {

   // let response = SessionService.get('components');
    let htmlTemplate = templateBase;

   /* if(response.CATEGORY_PAGER_TOOLBOX.component == 'template_t1'){
        htmlTemplate = template_t1;
    }*/

    return {
        restrict: 'E',
        template: htmlTemplate,
    };
}



export default accountMenuDirective;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/header-core/account-menu/account-menu.directive.js
 **/